import { mq } from '@kvdbil/components';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Auction from '~/App/shared/interfaces/Auction';
import { ReduxStore } from '~/App/shared/interfaces/store';
import { getAllRecentlyViewedAuctions } from '~/App/shared/reducers/recentlyViewedAuctionsReducer';
import { useTranslation } from '~/Locale';
import AuctionsSlideShow from './AuctionsSlideShow';

const Header = styled.div`
  margin-bottom: 1.5rem;
`;

const Heading = styled.h3`
  font-family: ${({ theme }) => theme.typography.fontAlternativeFamily};
  font-weight: ${({ theme }) => theme.typography.fontBaseRegularWeight};
  line-height: 1.325;
  font-size: 1.25rem;

  ${mq('tablet')} {
    font-size: 21px;
  }
`;

export interface RecentlyViewedAuctionsProps {
  auctions: Auction[];
}

export const RecentlyViewedAuctions = ({
  auctions
}: RecentlyViewedAuctionsProps) => {
  const { t } = useTranslation();
  const filteredUndefinedAuctions = auctions.filter(Boolean);
  const filteredAuctions = filteredUndefinedAuctions.filter(
    auction => auction.auctionType
  );

  if (filteredAuctions.length === 0) {
    return null;
  }

  return (
    <div>
      <Header>
        <Heading>{t('Recently viewed auctions')}</Heading>
      </Header>
      <div>
        <AuctionsSlideShow auctions={filteredUndefinedAuctions} />
      </div>
    </div>
  );
};

const mapStateToProps = (state: ReduxStore) => ({
  auctions: getAllRecentlyViewedAuctions(state.recentlyViewedAuctions)
});

export default connect(mapStateToProps)(RecentlyViewedAuctions);
